// Orden curado de categorías tal como se muestran en el menú.
const TIPOS = [
  "Entrada", "Sopa", "Chao-Fan (arroz)", "Chao-Mien (tallarines)", "Mi-Fen (fideos finos de arroz)",
  "Pan-Tiao (fideos anchos de arroz)", "Arroz con salsa de soja", "Arroz con salsa curry", "Chop-Suey", "Pollo", "Carne", "Cerdo",
  "Tofu", "Mariscos", "Especialidades", "Fideos con sopa / Ramen", "Arroz con salsa especial",
  "Za-Mien (Fideos crocantes con salsa de soja)", "Sushi (solo sábados y domingos)", "Postres",
  "Bebidas", "Cerveza & Soyu", "Café & Té", "Vinos"
];

export default TIPOS;
